/** student/endorsement-tags — API. */
import { http } from '../../_shared/http';
import type { EndorsementTagDefinition } from './types';

export const studentEndorsementTagsApi = {
  list: () => http.get<EndorsementTagDefinition[]>('/endorsement-tags'),
};
